import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class AllPortService {

  constructor(private http:HttpClient) { }

  createQuestion(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/allPort/createQuestion`, data);
  }

  getQuestions():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/allPort/getQuestions`);
  }
  getQuestion(id):Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/allPort/getQuestion?id=${id}`);
  }

  updateQuestion(data):Observable<any>{
    return this.http.put(`${environment.apiBaseUrl}/allPort/updateQuestion`, data);
  }

  createFactor(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/allPort/createFactor`, data)
  }

  getFactors():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/allPort/getFactors`);
  }

  createReport(score, answers, form):Observable<any>{
    const ob = {
      score:score,
      answers:answers,
      form:form
    }
    return this.http.post(`${environment.apiBaseUrl}/allPort/createReport`, ob)
  }

  updateRanks(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/allPort/updateRanks`, data);
  }

  getRanks():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/allPort/getRanks`);
  }

  getReport(id): Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/allPort/getReport?id=${id}`);
  }

}
